export default __webpack_public_path__ + "static/media/devices_2.99d6cf01.png";